import { render, staticRenderFns } from "./import-purchase-order.vue?vue&type=template&id=bb05758e&"
import script from "./import-purchase-order.vue?vue&type=script&lang=ts&"
export * from "./import-purchase-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports